import { useRef, useState } from "react";

// Control component state selection controlled and uncontrolled
function usePropsValue<T>(propsValue: T): [T, React.Dispatch<React.SetStateAction<T>>] {
  const isControlledRef = useRef(false);
  const [stateValue, setStateValue] = useState<T>(propsValue);

  if (propsValue !== undefined) {
    isControlledRef.current = true;
  }

  return [isControlledRef.current ? propsValue : stateValue, setStateValue];
}

export default usePropsValue;
